const Input = () => {
    return (
      <div class="fieldArea">
        <input type="text" placeholder="Enter Name" name="name" />
      </div>
    );
}

export default Input;